<div class="modal-header">
  <h5 class="modal-title" id="editUserLabel"></h5>
  <button type="button" class="close" (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="card-body">
    <h5 class="card-title"> {{item?.voce}}</h5>
    <div class="row">
      <div class="col-lg-6" >
        <div class="col-sm-12 col-lg-6" >
          <label  class="control-label col-form-label">Quantità</label>
          <input [(ngModel)]="send.quantita" type="number" min="0" [max]="item.quantita" class="form-control">
        </div>
        <label for="sedi" class="control-label col-form-label">SpostaIn:</label>
        <ng-multiselect-dropdown [settings]="DropdownSettings" [placeholder]="'Destinazione'" id="sedi" [data]="Other" [(ngModel)]="SelectedOther">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-lg-6"></div>

    </div>
  </div>
</div>


<div class="d-md-flex align-items-center justify-content-end m-b-10 m-r-10" >
  <button type="submit" (click)="Sposta()"  class=" btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> Sposta </span>
    <i-feather name="truck" class="feather-md "></i-feather>
  </button>
</div>
